module.exports = __webpack_public_path__ + "img/logo_pinglab.47e2592d.jpg";